document.addEventListener('DOMContentLoaded', function () {
    const bundleSelectorButtons = document.querySelectorAll('.bundle-selector__bundle');
    const bundleDetailCards = document.querySelectorAll('.details--wrapper .details');
    bundleSelectorButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            const selectorID = button.dataset.bundleSelector
            bundleSelectorButtons.forEach(btn => { btn.classList.remove('active') })
            button.classList.add('active')
            bundleDetailCards.forEach(card => { card.classList.remove('active') })
            document.querySelector(`[data-bundle-linked="${selectorID}"]`).classList.add('active')
            if (window.screen.width > 768) {
                window.scrollTo({ top: 332, behavior: 'smooth' });
            } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        })
    })
    const bundleSizeButtons = document.querySelectorAll('.weekly-meals__selector button');
    bundleSizeButtons.forEach(button => {
        button.addEventListener('click', function (event) {
            const detailsCard = event.currentTarget.closest(".details")
            event.currentTarget.closest(".weekly-meals__selector").querySelectorAll("button").forEach(btn => { btn.classList.remove('active') })
            button.classList.add('active')
            const selectedVariant = button.dataset.selectedVariant
            const variant = checkVariantMatcher(event)
            const price = `$${(variant.price / 100)}/week`
            const compare_at_price = `$${(variant.compare_at_price / 100)}/week`
            const priceElement = detailsCard.querySelector(".bundle__price")
            const priceComparedElement = detailsCard.querySelector(".bundle__price.compare-at-price")
            priceElement.innerHTML = price
            priceComparedElement.innerHTML = compare_at_price
            detailsCard.dataset.selectedVariant = selectedVariant
            detailsCard.querySelector(".details__add-to-cart").dataset.variantId = variant.id
            detailsCard.querySelector(".details__add-to-cart").dataset.sellingPlan = variant.selling_plan_allocations[0].selling_plan_id
        })
    })
    const bundlePortionButtons = document.querySelectorAll('.weekly-portion__selector button');
    bundlePortionButtons.forEach(button => {
        button.addEventListener('click', function (event) {
            const detailsCard = event.currentTarget.closest(".details")
            event.currentTarget.closest(".weekly-portion__selector").querySelectorAll("button").forEach(btn => { btn.classList.remove('active') })
            button.classList.add('active')
            const variant = checkVariantMatcher(event)
            const price = `$${(variant.price / 100)}/week`
            const compare_at_price = `$${(variant.compare_at_price / 100)}/week`
            const priceComparedElement = detailsCard.querySelector(".bundle__price.compare-at-price")
            const priceElement = detailsCard.querySelector(".bundle__price")
            priceElement.innerHTML = price
            priceComparedElement.innerHTML = compare_at_price
            detailsCard.querySelector(".details__add-to-cart").dataset.variantId = variant.id
            detailsCard.querySelector(".details__add-to-cart").dataset.sellingPlan = variant.selling_plan_allocations[0].selling_plan_id
        })
    })

    const addToCartButtons = document.querySelectorAll('.details__add-to-cart');
    addToCartButtons.forEach(button => {
        button.addEventListener('click', async function (event) {
            const defaultContent = button.innerHTML
            button.disabled = true
            button.innerHTML = `<i class="fa-solid fa-spinner fa-spin"></i> <span style="display: block; margin-left: 6px;">Adding to cart...
            </span>`
            const variant_id = button.dataset.variantId
            const selling_plan_id = button.dataset.sellingPlan
            const res = await cartHandler.addToCart({ variant_id, selling_plan_id, quantity: 1 })
            if (res) {
                globalFunctions.renderSections(res.sections["cart-icon-bubble"], document.querySelector('#cart-icon-bubble'))
                drawerCart.openDrawer();
                button.innerHTML = defaultContent
                button.disabled = false
            }
        })
    })

    // Seleciona todos os elementos com a classe .impact-numbers__block
    const impactNumbers = document.querySelectorAll('.impact-numbers__block');
    // Configurações do Intersection Observer
    const opcoes = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
    };
    // Função de callback que será chamada quando um elemento estiver visível
    function handleIntersection(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Chame sua função ou execute ações específicas aqui
                startIncrementalCount(entry.target);
                // Para de observar o elemento depois que ele estiver visível (opcional)
                observer.unobserve(entry.target);
            }
        });
    }
    // Para cada elemento com a classe .impact-numbers__block, cria um novo Intersection Observer
    impactNumbers.forEach(elemento => {
        const observer = new IntersectionObserver(handleIntersection, opcoes);
        observer.observe(elemento);
    });

})

function startIncrementalCount(element) {
    const number = element.querySelector('h3');
    const numberValue = parseInt(number.dataset.counter);
    const increment = numberValue / 100;
    let counter = 0;
    const timer = setInterval(() => {
        counter += increment;
        number.innerHTML = "+" + Math.round(counter).toLocaleString('en-US');
        if (counter >= numberValue) {
            clearInterval(timer);
        }
    }, 18);
}
function checkVariantMatcher(event) {
    const detailsCard = event.currentTarget.closest(".details")
    const detailsCardSelector = detailsCard.dataset.bundleLinked
    const bundleSize = detailsCard.querySelector(`.weekly-meals__selector button.active`)?.dataset.bundleSize
    const bundlePortion = detailsCard.querySelector(`.weekly-portion__selector button.active`)?.dataset.bundlePortion || null
    const products = window.bundle_sales_page[`selector_${detailsCardSelector}`]
    const variants = products.flatMap(product => product.variants.map(variant => variant))
    const variant = variants.find(variant => {
        if (bundlePortion === null) return variant.name.includes(bundleSize)
        return variant.name.includes(`${bundleSize} Mealz`) && variant.option1.includes(bundlePortion)
    })
    return variant;
}